import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from "@mui/material";
import { Controller, type FieldValues, type Path, type PathValue } from "react-hook-form";
import type { IFormGenInputProps } from "./index";
import { getFormGenEnumLabels, getFormGenEnumOptions } from "./logics";

export const FormGenInputChips = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
  jsonSchemaElement,
  multiple,
  enumOptions,
}: IFormGenInputProps<Schema, T>) => {
  const options = getFormGenEnumOptions(enumOptions, getFormGenEnumLabels(jsonSchemaElement, multiple));
  return (
    <Controller
      control={control}
      name={uiSchemaElement.scope as unknown as Path<T>}
      defaultValue={[] as unknown as PathValue<T, Path<T>>}
      render={({ field, fieldState }) => {
        const selected: string[] = Array.isArray(field.value) ? field.value : [];
        const toggle = (key: string) => {
          const next = selected.includes(key) ? selected.filter((value) => value !== key) : [...selected, key];
          field.onChange(next);
        };
        return (
          <FormControl error={Boolean(fieldState.error)} component="fieldset">
            <FormLabel component="legend">{uiSchemaElement.label}</FormLabel>
            <FormGroup row>
              {options.map((option) => (
                <FormControlLabel
                  key={option.key}
                  control={
                    <Checkbox
                      checked={selected.includes(option.key)}
                      onChange={() => toggle(option.key)}
                      value={option.key}
                    />
                  }
                  label={option.label}
                />
              ))}
            </FormGroup>
            {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
};
